/* ==========================================================================
   SEARCH-01 — intención de búsqueda · 10-ago-2026
   --------------------------------------------------------------------------
   Shopify busca con semántica OR y ordena por relevancia. Con «mesa centro
   fija» los productos «Mesa Comedor Fija …» casan 2 de 3 términos igual que
   las mesas de centro, y se colaban en 4ª posición. No era un caso aislado:
   «mesita de noche» acertaba un 25 %, «mesa auxiliar» un 50 %.

   Aquí se detecta el TIPO DE PRODUCTO dentro de lo que escribe la persona y se
   acota la búsqueda con `product_type:"…"`, que es sintaxis que Shopify SÍ
   entiende (comprobado: devuelve exactamente los 25 productos del tipo).
   El resto de términos se conserva únicamente si no deja la búsqueda a cero;
   para saberlo se consulta antes /search/suggest.json, que es barato.

   Medido en scripts/search_eval.py sobre 25 consultas: 89 % -> 100 %.

   El diccionario se genera del catálogo (los 30 productType). Si se añaden
   tipos nuevos hay que regenerarlo con scripts/search_intent_apply.py.

   Nada de esto puede dejar al usuario sin buscar: cualquier fallo, timeout o
   excepción cae al comportamiento de siempre.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__kfSearchIntent) return;
  window.__kfSearchIntent = true;

  /* ------------------------------------------------------------------
     I18N (F5) — el diccionario es POR IDIOMA, no global.
     Los disparadores (`t`) y sobre todo los `pt` son los 30 productType del
     catálogo EN ESPAÑOL. Con la tienda en francés no casaría ninguna entrada y,
     peor, `product_type:"Mesas de centro"` no acotaría nada porque el índice de
     búsqueda del idioma activo usa el product_type traducido.
     Por eso el diccionario se resuelve contra el idioma de la página:
       1. DICCIONARIOS[locale]                → integrado en este fichero
       2. window.KF_SEARCH_INTENT_DICTS[loc]  → inyectado desde Liquid (opcional)
       3. ASSETS_DICCIONARIO[locale]          → JSON hermano en /assets, diferido
     Si no hay diccionario para el idioma activo, `analizar()` devuelve null
     siempre y la búsqueda se comporta exactamente como la nativa de Shopify.
     Ese es hoy el caso del francés: PENDIENTE hasta que existan las
     traducciones FR de product_type (ver README de la fase).
  ------------------------------------------------------------------ */
  var DICCIONARIOS = {
    es: {
      tipos: [{"t": ["mesa", "auxiliare"], "pt": "Mesas auxiliares"}, {"t": ["mesa", "centro"], "pt": "Mesas de centro"}, {"t": ["mesa", "comedor"], "pt": "Mesas de comedor"}, {"t": ["silla", "comedor"], "pt": "Sillas de comedor"}, {"t": ["sillone", "relax"], "pt": "Sillones relax"}, {"t": ["sofa", "cama"], "pt": "Sofás cama"}, {"t": ["accesorio", "decorativo"], "pt": "Accesorios decorativos"}, {"t": ["panele", "acustico"], "pt": "Paneles acústicos"}, {"t": ["planta", "artificiale"], "pt": "Plantas artificiales"}, {"t": ["mesita", "noche"], "pt": "Mesitas de noche"}, {"t": ["conjunto", "terraza"], "pt": "Conjuntos terraza"}, {"t": ["mesa", "exterior"], "pt": "Mesas de exterior"}, {"t": ["mueble", "exterior"], "pt": "Muebles de exterior"}, {"t": ["silla", "exterior"], "pt": "Sillas de exterior"}, {"t": ["silla", "oficina"], "pt": "Sillas de oficina"}, {"t": ["recambio", "accesorio"], "pt": "Recambios y accesorios"}, {"t": ["butaca"], "pt": "Butacas"}, {"t": ["estanteria"], "pt": "Estanterías"}, {"t": ["puf"], "pt": "Pufs"}, {"t": ["sofa"], "pt": "Sofás"}, {"t": ["taburete"], "pt": "Taburetes"}, {"t": ["espejo"], "pt": "Espejos"}, {"t": ["armario"], "pt": "Armarios"}, {"t": ["baule"], "pt": "Baúles"}, {"t": ["cabecero"], "pt": "Cabeceros"}, {"t": ["cama"], "pt": "Camas"}, {"t": ["escritorio"], "pt": "Escritorios"}, {"t": ["banco"], "pt": "Bancos"}, {"t": ["consola"], "pt": "Consolas"}, {"t": ["zapatero"], "pt": "Zapateros"}],
      vacias: ["de", "del", "la", "el", "los", "las", "para", "con", "y", "o", "en", "un", "una", "al", "mi", "su", "que", "por"]
    }
  };

  /* Diccionarios servidos como asset JSON, por idioma: { locale: 'fichero.json' }.
     Vacío a propósito — en cuanto exista assets/kifoni-search-intent.fr.json
     (mismo formato que DICCIONARIOS.es: { "tipos": [...], "vacias": [...] })
     basta con añadir aquí  fr: 'kifoni-search-intent.fr.json'  y queda activo.
     La URL se deriva del src de este mismo <script>, así que no hace falta que
     Liquid inyecte nada. */
  var ASSETS_DICCIONARIO = {};

  var SELF_SRC = (document.currentScript && document.currentScript.src) || '';

  function localeActivo() {
    var l = '';
    try { l = (window.Shopify && window.Shopify.locale) || ''; } catch (e) { l = ''; }
    if (!l) l = document.documentElement.getAttribute('lang') || '';
    return String(l).toLowerCase().split('-')[0];
  }

  var LOCALE = localeActivo();
  var INYECTADOS = window.KF_SEARCH_INTENT_DICTS || {};
  var DICC = INYECTADOS[LOCALE] || DICCIONARIOS[LOCALE] || null;

  /* Sin diccionario para este idioma: listas vacías = cero interceptaciones. */
  var TIPOS = DICC && DICC.tipos ? DICC.tipos : [];
  var VACIAS = DICC && DICC.vacias ? DICC.vacias : [];

  /* Carga diferida del diccionario del idioma activo desde /assets. No bloquea:
     hasta que llega (o si no llega nunca) la búsqueda es la nativa. */
  function cargarDiccionarioRemoto() {
    var fichero = ASSETS_DICCIONARIO[LOCALE];
    if (DICC || !fichero || !SELF_SRC || typeof fetch !== 'function') return;
    var url = SELF_SRC.replace(/[^/]+(\?.*)?$/, fichero);
    fetch(url, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.tipos || !d.tipos.length) return;
        TIPOS = d.tipos;
        VACIAS = d.vacias || [];
      })
      .catch(function () { /* el buscador nativo sigue funcionando */ });
  }
  var LIMITE_MS = 900;

  function norm(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }
  function sing(w) { return w.length > 3 && w.slice(-1) === 's' ? w.slice(0, -1) : w; }
  function toks(q) {
    return norm(q).match(/[a-z0-9]+/g) ? norm(q).match(/[a-z0-9]+/g).filter(function (t) {
      return VACIAS.indexOf(t) === -1;
    }) : [];
  }
  /* tolerante con plurales irregulares: baul/baules */
  function igual(a, b) {
    if (a === b) return true;
    var c = a.length <= b.length ? a : b, d = a.length <= b.length ? b : a;
    return c.length >= 4 && d.indexOf(c) === 0;
  }

  function analizar(q) {
    var qt = toks(q).map(sing);
    if (!qt.length) return null;
    for (var i = 0; i < TIPOS.length; i++) {
      var tk = TIPOS[i].t;
      var todos = tk.every(function (t) {
        return qt.some(function (x) { return igual(t, x); });
      });
      if (todos) {
        var resto = toks(q).filter(function (t) {
          return !tk.some(function (x) { return igual(sing(t), x); });
        });
        return { pt: TIPOS[i].pt, resto: resto };
      }
    }
    return null;
  }

  function scoped(pt, resto) {
    var base = 'product_type:"' + pt + '"';
    return resto && resto.length ? base + ' ' + resto.join(' ') : base;
  }

  /* Endpoint de sugerencias DEL IDIOMA ACTIVO.
     layout/theme.liquid ya publica window.routes.predictive_search_url desde
     Liquid: devuelve '/search/suggest' en el idioma principal y
     '/fr/search/suggest' cuando la URL lleva raíz de idioma. Con la ruta escrita
     a mano la sonda consultaba SIEMPRE el índice de búsqueda español, así que en
     francés habría decidido con resultados del idioma equivocado si conservar o
     no los términos extra. Hoy no llega a dispararse en francés (sin diccionario
     `analizar()` devuelve null), pero el enganche queda correcto para cuando
     exista el diccionario FR. En español la URL resultante es idéntica a la de
     antes. */
  function urlSugerencias() {
    var base = (window.routes && window.routes.predictive_search_url) || '/search/suggest';
    return base.indexOf('.json') === -1 ? base + '.json' : base;
  }

  /* ¿la consulta acotada CON los términos extra devuelve algo? */
  function hayResultados(q) {
    /* kfskip: marca para que el interceptor de fetch de más abajo NO vuelva a
       procesar esta petición. Sin esto se reescribía a sí misma y la sonda
       respondía que sí había resultados cuando no los había. */
    var url = urlSugerencias() + '?kfskip=1&q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=1';
    var ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var t = setTimeout(function () { if (ctrl) ctrl.abort(); }, LIMITE_MS);
    return fetch(url, ctrl ? { signal: ctrl.signal } : undefined)
      .then(function (r) { return r.json(); })
      .then(function (d) {
        clearTimeout(t);
        var p = d && d.resources && d.resources.results && d.resources.results.products;
        return !!(p && p.length);
      })
      .catch(function () { clearTimeout(t); return false; });
  }

  /* devuelve una promesa con la consulta final */
  function resolver(q) {
    var a = analizar(q);
    if (!a) return Promise.resolve(null);
    if (!a.resto.length) return Promise.resolve(scoped(a.pt, []));
    var con = scoped(a.pt, a.resto);
    return hayResultados(con).then(function (ok) { return ok ? con : scoped(a.pt, []); });
  }

  /* ---- 1 · envío del formulario ---------------------------------------- */
  function engancharFormularios() {
    document.querySelectorAll('form[action*="/search"]').forEach(function (form) {
      if (form.__kfEnganchado) return;
      form.__kfEnganchado = true;
      form.addEventListener('submit', function (ev) {
        try {
          if (form.__kfListo) { form.__kfListo = false; return; }
          var input = form.querySelector('input[name="q"]');
          if (!input || !input.value.trim()) return;
          var original = input.value.trim();
          if (original.indexOf('product_type:') === 0) return;
          if (!analizar(original)) return;          /* sin tipo: como siempre */
          ev.preventDefault();
          resolver(original).then(function (q) {
            if (q) {
              input.value = q;
              /* la consulta original viaja aparte para poder mostrarla */
              var h = form.querySelector('input[name="kfq"]');
              if (!h) {
                h = document.createElement('input');
                h.type = 'hidden'; h.name = 'kfq';
                form.appendChild(h);
              }
              h.value = original;
            }
            /* Fuera del despacho del propio evento submit: si se llama a
               requestSubmit() dentro, el navegador lo ignora y la búsqueda se
               queda en la página actual (pasaba con consultas sin términos
               extra, donde la promesa se resuelve en el mismo tick). */
            form.__kfListo = true;
            setTimeout(function () {
              if (typeof form.requestSubmit === 'function') form.requestSubmit();
              else form.submit();
            }, 0);
          });
        } catch (e) { /* nunca dejar sin buscar */ }
      });
    });
  }

  /* ---- 2 · desplegable predictivo -------------------------------------- */
  var fetchOriginal = window.fetch;
  window.fetch = function (recurso, opciones) {
    try {
      var url = typeof recurso === 'string' ? recurso : (recurso && recurso.url) || '';
      if (url.indexOf('/search/suggest') !== -1 && url.indexOf('kfskip=1') === -1) {
        var m = url.match(/[?&]q=([^&]*)/);
        if (m) {
          var q = decodeURIComponent(m[1].replace(/\+/g, ' '));
          /* la URL viaja codificada: hay que mirar la q ya decodificada */
          if (q.indexOf('product_type:') === 0) return fetchOriginal.call(this, recurso, opciones);
          var a = analizar(q);
          if (a) {
            var nuevo = url.replace(/([?&]q=)[^&]*/, '$1' + encodeURIComponent(scoped(a.pt, a.resto)));
            return fetchOriginal.call(this, nuevo, opciones).then(function (r) {
              return r.clone().json().then(function (d) {
                var p = d && d.resources && d.resources.results && d.resources.results.products;
                if (p && p.length) return r;
                /* si los términos extra lo vacían, se prueba solo con el tipo */
                var solo = url.replace(/([?&]q=)[^&]*/, '$1' + encodeURIComponent(scoped(a.pt, [])));
                return fetchOriginal.call(window, solo, opciones);
              }).catch(function () { return r; });
            });
          }
        }
      }
    } catch (e) { /* seguir con la petición original */ }
    return fetchOriginal.call(this, recurso, opciones);
  };

  /* ---- 3 · en la página de resultados, enseñar lo que escribió ---------- */
  function restaurarTexto() {
    try {
      var kfq = new URLSearchParams(location.search).get('kfq');
      if (!kfq) return;
      document.querySelectorAll('input[name="q"]').forEach(function (i) { i.value = kfq; });
      var q = new URLSearchParams(location.search).get('q') || '';
      document.querySelectorAll('h1, h2, p[role="status"]').forEach(function (el) {
        if (el.textContent && el.textContent.indexOf(q) !== -1) {
          el.textContent = el.textContent.split(q).join(kfq);
        }
      });
    } catch (e) { /* cosmético, no debe romper nada */ }
  }

  function init() { cargarDiccionarioRemoto(); engancharFormularios(); restaurarTexto(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', engancharFormularios);
})();
